import { useChatContext } from '@almai1/chatbot-widget'
import { useTranslation } from 'react-i18next'
import { SuggestionButtons } from '../../cards/SuggestionButtons'
import { useHasSuggestionButtons } from '../../hooks/useHasSuggestionButtons'

export function SuggestionButtonsBar() {
  const { sendMessage } = useChatContext()
  const { buttonsData } = useHasSuggestionButtons()
  const { t } = useTranslation()

  if (!buttonsData) return null

  return (
    <div className="suggestion-buttons-bar">
      <span className="suggestion-buttons-label">{t('widget.chooseOption')}</span>
      <div className="suggestion-buttons-scroll">
        <SuggestionButtons data={buttonsData} onSendMessage={sendMessage} />
      </div>
    </div>
  )
}
